export default __webpack_public_path__ + "static/media/kabir2.222edb54.jpg";